import { render, staticRenderFns } from "./TextLink.vue?vue&type=template&id=65b63e11"
import script from "./TextLink.vue?vue&type=script&lang=ts"
export * from "./TextLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports